/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import './CustomScheduledItems.scss';
import { Tooltip } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider } from 'react-intl';
import CustomScheduledItemsSettings from './CustomScheduledItems.settingsForm';
import getLocalParams from '../localizationCustoms';

const CustomScheduledItems = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      options: [],
    };
    this.setValue = this.setValue.bind(this);
    this.checked = this.checked.bind(this);
  }

  componentDidMount() {
    const { state: { value }, props: { onChange } } = this;
    // get scheduledItems from sessionStorage
    let scheduledItems = JSON.parse(sessionStorage.getItem('scheduledItems'));
    if (scheduledItems?.length) {
      scheduledItems = scheduledItems.map((item) => ({ label: `$${item.value} ${item.description}`, description: item.description, estimatedValue: item.value }));
      this.setState({
        value,
        options: scheduledItems,
      }, () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    }
  }

  setValue = (v) => {
    const { state: { value, options }, props: { onChange, component: { useReviewLabel, reviewLabel, label } } } = this;

    const checkboxValue = options.find((option) => option.label === v);
    if (value && value.selectedValues) {
      if (value.selectedValues.some((c) => c.label === v)) {
        this.setState({
          value: {
            selectedValues: value.selectedValues.filter((c) => c.label !== v),
            review: { label: useReviewLabel ? reviewLabel : label, valueKey: 'label' },
          },
        }, () => {
          // eslint-disable-next-line react/destructuring-assignment
          onChange(this.state.value);
        });
      } else if (!value.selectedValues.some((c) => c.label === v)) {
        this.setState((prevState) => ({
          value: { selectedValues: [...prevState.value.selectedValues, checkboxValue], review: { label: useReviewLabel ? reviewLabel : label, valueKey: 'label' } },

        }), () => {
          // eslint-disable-next-line react/destructuring-assignment
          onChange(this.state.value);
        });
      }
    } else {
      this.setState({
        value: { selectedValues: [checkboxValue], review: { label: useReviewLabel ? reviewLabel : label, valueKey: 'label' } },
      }, () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    }
  };

  checked = (checkboxValue) => {
    const { value } = this.state;
    if (value && value.selectedValues) {
      if (value.selectedValues.some((selectedValue) => selectedValue.label === checkboxValue)) { return true; }
    }
    return false;
  };

  render() {
    const { state: { options }, props: { component: { hideCustomLabel, label, tooltip }, disabled } } = this;

    return (
      options.length
        ? (
          <>
            {!hideCustomLabel && (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <label className="label-question">
                <FormattedMessage id={label} defaultMessage={label} />
              </label>
              {tooltip !== '' && (
              <Tooltip id="multipleroundedcheckboxes_tooltip" primary>
                <FormattedMessage id={tooltip} defaultMessage={tooltip} />
              </Tooltip>
              )}
            </div>
            )}

            <div className="multiple-checkboxes--wrapper">
              {options.map((checkboxObj) => {
                const mCheckboxId = `id_mcheckbox_${Math.random() * 0xffffffffffff}`;
                return (
                  <div // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                    tabIndex="0"
                    aria-labelledby={checkboxObj.label}
                    role="group"
                    id={`id_div_${mCheckboxId}`}
                    key={`key_div_${mCheckboxId}`}
                    className="div-multiple-checkboxes"
                  >
                    <input
                      type="checkbox"
                      disabled={disabled}
                      id={mCheckboxId}
                      key={`key_m_checkbox_${Math.random() * 0xffffffffffff}`}
                      className={`multiple-checkboxes${!this.checked(checkboxObj.label) ? '' : ' multiple-checkboxes--checked'}`}
                      value={checkboxObj.label}
                      onChange={(newValue) => this.setValue(newValue.target.value)}
                      checked={this.checked(checkboxObj.label)}
                    />
                    <label htmlFor={mCheckboxId}>
                      <FormattedMessage id={checkboxObj.label} defaultMessage={checkboxObj.label} />
                    </label>
                  </div>
                );
              })}
            </div>
          </>
        ) : null
    );
  }
};

export default class ScheduledItemsComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom ScheduledItems',
      group: 'basic',
      icon: 'check-square',
      documentation: '',
      weight: 50,
      schema: ScheduledItemsComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customScheduledItems',
      },
      ...extend,
    );
  }

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  static editForm = CustomScheduledItemsSettings;

  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomScheduledItems
          ref={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          onChange={this.updateValue} // The onChange event to call when the value changes.
        />
      </IntlProvider>,
      element,
      // eslint-disable-next-line no-return-assign
      () => (this.reactInstance = instance),
    );
  }

  // eslint-disable-next-line class-methods-use-this
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
